import styles from './LinkSetTitle.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';
import { LinkSet } from 'src/api/contentful/contentTypes.cloverdotcom';
import { MaterialIcon } from 'src/components/MaterialIcon/MaterialIcon';
import { getField, isEntry } from 'src/utils/EntryUtil';

export interface ILinkSetTitle extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  entry?: ReferencedEntry<LinkSet>;
  expanded?: boolean;
  showCaret?: boolean;
  titleTag?: string;
  isMobile?: boolean;
}

export const LinkSetTitle = React.forwardRef<HTMLButtonElement | HTMLSpanElement, ILinkSetTitle>(({
  entry, showCaret, expanded, className, isMobile, titleTag= 'span', ...props
}, ref) => {
  if (!isEntry(entry)) return null;

  const styleClass = { className: titleTag === 'h5' ? null : styles.item };
  const icon = expanded ? 'expand_less' : 'expand_more';

    const title = getField(entry, 'title');
    return (
      <button
        className={cx(className, styles.wrapper)}
        {...props}
        ref={ref as React.Ref<HTMLButtonElement>}
        aria-label={expanded ? `Hide ${title}` : `Expand ${title} for More`}
      >
        {title && React.createElement(titleTag, styleClass, title)}
        {showCaret && !isMobile && (
          <MaterialIcon
            className={cx(styles.item, styles.caret)}
            icon={icon}
          />
        )}
      </button>
    );
});
